import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { editMachine, selectCurrentMachine, selectPristineMachine, setEditorErrors } from "./machinesSlice";
import { Editor } from "../../common/components/Editor";

export const MachineEditor = ({ header }) => {
  const [view, setView] = useState("edit");
  const { content = '' } = useSelector(selectCurrentMachine);
  const { content: pristineContent = '' } = useSelector(selectPristineMachine);

  const dispatch = useDispatch();
  const changeView = (data) => setView(data);

  const handleJsonChange = (value, event) => {
    var parsed = {};
    try {
      parsed = JSON.parse(value);
    } catch (error) {
      console.error(error);
      parsed = pristineContent;
    } finally {
      dispatch(
        editMachine({
          content: parsed,
        })
      );
    }
  };
  const handleEditorValidation = (markers) => {
    dispatch(setEditorErrors(markers));
  }

  return (
    <Editor
      header={header}
      view={view}
      setView={changeView}
      json={content}
      pristineJson={pristineContent}
      handleJsonChange={handleJsonChange}
      handleValidationErrors={handleEditorValidation}
    />
  );
};
